import React from 'react';
import { useSelector } from 'react-redux';
import SimpleMantenedorLayout from '../../components/SimpleMantenedorLayout';
import { useMantenedores } from '../../context/MantenedoresContext';
import { useTarifariosErroresMantenedor } from '../../hooks/useTarifariosErroresMantenedor';
import ErroresTarifariosResumenComponent from '../../components/Tarifarios/ErroresTarifariosResumenComponent';

const ErroresTarifarios = () => {
    const user = useSelector(state => state.auth.user);
    const { userPermissions } = useMantenedores();
    const permisos = userPermissions?.modules?.tarifarios || {};

    const {
        resumenErrores,
        loading,
        error,
        handleViewErrorDetail,
        handleViewEmpresaErrorDetail
    } = useTarifariosErroresMantenedor(user, permisos);

    return (
        <SimpleMantenedorLayout
            mantenedorId="tarifarios"
            title="Errores de Tarifario"
            subtitle="Gestión y corrección de errores en tarifarios"
            iconColor="#dc3545"
            showBackButton={false}
            backButtonPath="/mantenedores/tarifarios"
            breadcrumbs={[
                {
                    label: 'Tarifarios',
                    path: '/mantenedores/tarifarios'
                },
                {
                    label: 'Errores de Tarifario'
                }
            ]}
        >
            {error && <div className="alert alert-danger mb-2">{error}</div>}
            
            <ErroresTarifariosResumenComponent
                resumenErrores={resumenErrores}
                loading={loading}
                onViewDetail={handleViewErrorDetail}
                onViewEmpresaDetail={handleViewEmpresaErrorDetail}
            />
        </SimpleMantenedorLayout>
    );
};

export default ErroresTarifarios;
